import axios from 'axios';

class InvoiceCopyService {
  get (ocr, companyId) {
    return axios.get(`backend://invoice/copy?ocr=${ocr}&customer_id=${companyId}`)
      .then((response) => response.data.data.attributes);
  }
}

export default new InvoiceCopyService();



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/invoice-copy/invoice-copy-service.js
 **/